import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { filter, fromEvent, Subscription } from 'rxjs';

@Directive({
  selector: '[appClickOutside]',
})
export class ClickOutsiteDirective implements AfterViewInit, OnDestroy {
  constructor(
    private element: ElementRef,
    @Inject(DOCUMENT)
    private document: Document
  ) {}

  @Output()
  public clickOutside = new EventEmitter<void>();

  public documentClickSubscription: Subscription | undefined;

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.documentClickSubscription = fromEvent(this.document, 'click').pipe(
        filter((event) => {
          return !this.isInside(event.target as HTMLElement);
        })
      )
      .subscribe(() => {
        this.clickOutside.emit()
      })
    }, 0);
  }

  public ngOnDestroy(): void {
    this.documentClickSubscription?.unsubscribe();
  }

  private isInside(elementToCheck: HTMLElement): boolean {
    return (
      elementToCheck === this.element.nativeElement ||
      this.element.nativeElement.contains(elementToCheck)
    );
  }
}
